import React from 'react';
import { FileText, Target, AlertCircle, History } from 'lucide-react';
import './HowItWorks.css';

const HowItWorks = () => {
  const features = [
    {
      icon: FileText,
      title: 'Policy Engine',
      description: 'Define governance guardrails.',
    },
    {
      icon: Target,
      title: 'Alignment Scoring',
      description: 'Ensure messaging aligns with company strategy.',
    },
    {
      icon: AlertCircle,
      title: 'Risk Detection',
      description: 'Detect reputational and compliance exposure.',
    },
    {
      icon: History,
      title: 'Immutable Audit Logs',
      description: 'Track governance decisions and communication history.',
    },
  ];

  return (
    <section className="how-it-works section" data-testid="how-it-works-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title" data-testid="how-it-works-title">How It Works</h2>
          <p className="section-subtitle">
            Four pillars of AI communication governance
          </p>
        </div>
        
        <div className="features-grid" data-testid="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card" data-testid={`feature-card-${index}`}>
              <div className="feature-icon-wrapper">
                <feature.icon size={24} className="feature-icon" />
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
              <div className="feature-number">{String(index + 1).padStart(2, '0')}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
